import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { BntCredentialsModel }      from './models/bnt.credentials';
import { BntService }               from './bnt.service';
import { BntSettingsComponent }     from './bnt.settings.component';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { CompanyService }           from '../companies/company.service';
import { SessionService }           from '../sessions/session.service';

export const BntStates : Array<NgHybridStateDeclaration> = [
  {
    component: BntSettingsComponent,
    name     : 'app.bnt-settings',
    resolve  : [
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : ng.IPromise<any> => sessionService.refresh(),
        token    : 'session'
      },
      {
        deps     : [ BntService ],
        resolveFn: ( bntService : BntService ) : ng.IPromise<CompanyIntegrationsModel> => bntService.getSettings(),
        token    : 'settings'
      },
      {
        deps     : [ 'session', BntService, CompanyService ],
        resolveFn: (
          session       : any,
          bntService    : BntService,
          companyService: CompanyService
        ) : ng.IPromise<BntCredentialsModel> => companyService.hasIntegration('bnt')
          ? bntService.getCredentials()
          : null,
        token: 'credentials'
      }
    ],
    url: '/bnt-settings'
  }
];
